import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import thunk from "redux-thunk";
import * as actionTypes from "./store/actionTypes";
import authReducer from "./store/reducers/auth";
import profileReducer from './store/reducers/profile';
import languageReducer from './store/reducers/language';
import categoryReducer from './store/reducers/category';
import subscriptionReducer from './store/reducers/subscription';
import chatsReducer from './store/reducers/chats';
import productReducer from './store/reducers/products';
import locationReducer from './store/reducers/location';
import notificationReducer from './store/reducers/notification';
import headerReducer from './store/reducers/header';
import favoritesReducer from './store/reducers/favorites';
import filterReducer from './store/reducers/filters';
import servicesReducer from './store/reducers/services';

const composeEnhancers = (process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;

const appReducer = combineReducers({
  auth: authReducer,
  profile: profileReducer,
  language: languageReducer,
  category: categoryReducer,
  subscription: subscriptionReducer,
  chats: chatsReducer,
  product: productReducer,
  locations: locationReducer,
  notification: notificationReducer,
  header: headerReducer,
  favorites: favoritesReducer,
  filters: filterReducer,
  services:  servicesReducer,
});

const rootReducer = (state, action) => {
  if (action.type === actionTypes.RESET_STORE) {
    state = undefined;
  }
  return appReducer(state, action);
}

export const resetStore = () => ({
  type: actionTypes.RESET_STORE,
});

const store = createStore(rootReducer, composeEnhancers(
  applyMiddleware(thunk)
));

export default store;
